import { useState } from "react";
import { useSEO } from "@/hooks/use-seo";
import { ArrowRight, CheckCircle, XCircle, ChevronDown, ChevronUp, Star, Trophy, Shield, BookOpen, AlertTriangle, HelpCircle, UserPlus, CreditCard, Sparkles, Gamepad2, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

import logo3  from "@assets/logos_extracted/3.png";
import logo6  from "@assets/logos_extracted/6.png";
import logo7  from "@assets/logos_extracted/7.png";
import logo8  from "@assets/logos_extracted/8.png";
import logo13 from "@assets/logos_extracted/13.png";

import screenshotSpinanga  from "@assets/Screenshot_2026-03-08_152738_1773146768819.png";
import screenshotRabona    from "@assets/Screenshot_2026-03-08_152813_1773146768819.png";
import screenshotCasinia   from "@assets/Screenshot_2026-03-08_153004_1773146768819.png";
import screenshotAlf       from "@assets/Screenshot_2026-03-08_153031_1773146768819.png";

const TOP5 = [
  {
    rank: 1,
    name: "Spinanga",
    logo: logo6,
    screenshot: screenshotSpinanga,
    url: "https://spng.fynkelto.com/?mid=279656_1645837",
    reviewUrl: "/kasina/spinanga",
    headline: "100 % až do výše 12 500 Kč + 200 roztočení zdarma",
    subline: "Uvítací bonus ve Spinangě",
    pros: [
      "Vysoký finanční bonus kombinovaný s velkým množstvím spinů.",
      "Jasně definované a standardní podmínky.",
      "Denní přísun spinů podporuje pravidelnou zábavu.",
    ],
    cons: [
      "Wagering požadavek zahrnuje i vklad, což zvyšuje celkovou částku k protočení.",
      "Minimální vklad 250 Kč je vyšší než u některých konkurentů.",
    ],
    desc: "Spinanga Casino nabízí na českém trhu štědrý a transparentní uvítací bonus: 100% k prvnímu vkladu až 12 500 Kč + 200 free spinů, uvolňovaných po 20 denně po dobu 10 dní, což podporuje pravidelnou hru a využití bonusu na populární automaty.",
    params: [
      { label: "Výše bonusu",               value: "100 % až do 12 500 Kč + 200 free spinů" },
      { label: "Minimální vklad",           value: "250 Kč" },
      { label: "Požadavky na protočení",    value: "35× (vklad + bonus)" },
      { label: "Platnost bonusu",           value: "10 dní od aktivace" },
    ],
    detail: "Je důležité si uvědomit, že požadavek na protočení se vztahuje jak na bonus, tak na vklad. To znamená, že při maximálním vkladu 12 500 Kč a zisku bonusu 12 500 Kč je nutné prosázet celkem (12 500 + 12 500) × 35 = 875 000 Kč. Vyšší minimální vklad může být pro některé začátečníky překážkou, ale pro seriózní hráče představuje standardní vstupní bránu k hodnotné odměně.",
    tip: "Jelikož jsou free spiny připsány po částech, nastavte si denní připomenutí. Předejdete tak situaci, kdy by vám kvůli zapomenutí propadla část bonusu.",
  },
  {
    rank: 2,
    name: "Rabona",
    logo: logo7,
    screenshot: screenshotRabona,
    url: "https://rbn.fynkelto.com/?mid=279656_1645828",
    reviewUrl: "/kasina/rabona",
    headline: "100% bonus k prvnímu vkladu až 12 500 Kč + 200 free spinů",
    subline: "Uvítací bonus v Rabona",
    pros: [
      "Atraktivní vstupní bonus kombinující peníze a free spiny.",
      "Důvěryhodný a zavedený operátor.",
      "Přehledné a transparentní podmínky bonusů.",
    ],
    cons: [
      "Některé akce jsou časově omezené a vyžadují aktivní sledování.",
      "Vkladové bonusy jsou vázány na standardní požadavky na protočení.",
    ],
    desc: "Rabona Casino nabízí 100% bonus k prvnímu vkladu až 12 500 Kč + 200 free spinů postupně uvolňovaných, kombinující kasinovou zábavu se sportovním sázením. Pravidelné promo akce a turnaje činí platformu atraktivní i pro zkušené hráče.",
    params: [
      { label: "Výše bonusu",               value: "100 % až do 12 500 Kč + 200 free spinů" },
      { label: "Minimální vklad",           value: "250 Kč pro získání bonusu" },
      { label: "Požadavky na protočení",    value: "Variabilní (často 35× pro vkladové bonusy)" },
      { label: "Platnost bonusu",           value: "Obvykle 10 dní" },
    ],
    detail: "Je klíčové si uvědomit, že jednotlivé bonusy mají specifická pravidla. Bonus je připsán automaticky po prvním vkladu, zatímco free spiny jsou uvolňovány v balíčcích po 20 denně. Tato struktura dává hráčům flexibilitu.",
    tip: "Pravidelně sledujte sekci 'Promo akce' na webu Rabona. Často se zde objevují krátkodobé promo akce, jako jsou free spiny na nové hry nebo bonusy za vklad v konkrétní dny.",
  },
  {
    rank: 3,
    name: "Legiano",
    logo: logo3,
    screenshot: null,
    url: "https://lgno.monvaki.com/?mid=282906_1666929",
    reviewUrl: "/kasina/legiano",
    headline: "Bonus bez vkladu jako skvělý start",
    subline: "Registrační bonus zdarma v Legiano",
    pros: [
      "Štědrý bonus s free spiny jen za registraci.",
      "Vysoký limit vkladového bonusu pro náročnější hráče.",
      "Pravidelné turnaje a promo týdny udržují hráče v akci.",
    ],
    cons: [
      "Informace o některých bonusových podmínkách jsou dostupné až po přihlášení.",
      "Častá obměna promoakcí vyžaduje aktivní sledování ze strany hráče.",
    ],
    desc: "Legiano nabízí registrační bonus bez vkladu ve formě free spinů, který umožňuje novým hráčům vyzkoušet automaty bez rizika, a k tomu vkladový bonus až 12 500 Kč pro zkušené hráče.",
    params: [
      { label: "Registrační bonus",         value: "Free spiny bez vkladu" },
      { label: "Vkladový bonus",            value: "Až do 12 500 Kč" },
      { label: "Požadavky na protočení",    value: "35× (výhry z free spinů)" },
      { label: "Platnost bonusu",           value: "7 dní od registrace" },
    ],
    detail: "Důležité je, že požadavek na protočení se vztahuje na výhry získané z volných zatočení, nikoli na jejich hodnotu. To je pro hráče výhodnější. Kasino je také známé svými pravidelnými promoakcemi a turnaji, které udržují herní zážitek svěží a dynamický.",
    tip: "Sledujte pravidelně sekci promoakcí na webu Legiano. Často se zde objevují časově omezené nabídky a turnaje s atraktivními cenami, které mohou výrazně navýšit váš herní kapitál.",
  },
  {
    rank: 4,
    name: "Casinia",
    logo: logo8,
    screenshot: screenshotCasinia,
    url: "https://csn.fynkelto.com/?mid=279656_1645835",
    reviewUrl: "/kasina/casinia",
    headline: "100% bonus k prvnímu vkladu až 12 500 Kč + 200 free spinů",
    subline: "Uvítací balíček v Casinia",
    pros: [
      "Vysoká celková hodnota bonusového balíčku.",
      "Silná a důvěryhodná značka.",
      "Transparentní podmínky a široká nabídka her.",
    ],
    cons: [
      "Požadavek na protočení zahrnuje vklad i bonus.",
      "Časové limity pro splnění podmínek mohou být pro začátečníky náročné.",
    ],
    desc: "Casinia nabízí 100% bonus k prvnímu vkladu až 12 500 Kč + 200 free spinů jako komplexní uvítací balíček, ideální pro postupné budování herního kapitálu, s možností dalších promo akcí jako cashback a turnaje.",
    params: [
      { label: "Výše bonusu",               value: "Až 12 500 Kč + 200 free spinů" },
      { label: "Minimální vklad",           value: "Obvykle od 250 Kč" },
      { label: "Požadavky na protočení",    value: "35× (vklad + bonus)" },
      { label: "Platnost bonusu",           value: "Časově omezeno (ověřit v podmínkách)" },
    ],
    detail: "Požadavek na protočení se vztahuje na součet vkladu a bonusu, což je standardní, ale náročnější podmínka. Celková hodnota balíčku nejvíce ocení zkušení hráči, kteří hledají jedny z nejlepších casino bonusů na trhu a jsou připraveni splnit náročnější podmínky.",
    tip: "Před aktivací bonusu si pečlivě prostudujte jeho specifické podmínky a časový limit. Vytvořte si plán, jak a na kterých hrách budete požadavek na protočení plnit.",
  },
  {
    rank: 5,
    name: "Alf Casino",
    logo: logo13,
    screenshot: screenshotAlf,
    url: "https://alcw.monvaki.com/?mid=282906_1667062",
    reviewUrl: "/kasina/alf-casino",
    headline: "Bonus 100% až do 20 000 Kč",
    subline: "Uvítací bonus v Alf Casino",
    pros: [
      "Atraktivní uvítací bonus za první vklad.",
      "Velmi jasné a srozumitelné bonusové podmínky.",
      "Široká nabídka her a moderní design platformy.",
    ],
    cons: [
      "Kratší platnost bonusu ve srovnání s některými konkurenty.",
      "Některé promo akce jsou časově omezené, vyžadují pravidelné sledování webu.",
    ],
    desc: "Alf Casino se odlišuje svým jednoduchým přístupem k novým hráčům. Nabízí uvítací bonus 100% až do 20 000 Kč doplněný o balíček free spinů, takže si začátečníci mohou vyzkoušet kasino bez složitých vkladových balíčků a komplikací.",
    params: [
      { label: "Výše bonusu",               value: "100 % bonus až do 20 000 Kč + 300 free spinů" },
      { label: "Minimální vklad",           value: "250 Kč (pro vkladový bonus)" },
      { label: "Požadavky na protočení",    value: "35× (vklad + bonusová částka)" },
      { label: "Platnost bonusu",           value: "10 dní (pro vkladový bonus)" },
    ],
    detail: "U vkladového bonusu se požadavek na protočení vztahuje na součet vkladu a získané bonusové částky, což je pro hráče standardní, ale náročnější podmínka. Krátká platnost bonusu (10 dní) může vyžadovat od hráčů aktivnější přístup ke splnění podmínek.",
    tip: "Využijte nejprve demo verze her k otestování různých automatů a herních mechanik. Zjistíte tak, které vám nejvíce vyhovují, ještě předtím, než se rozhodnete pro první vklad.",
  },
];

const COMPARISON = [
  { name: "Spinanga",     bonus: "100% až do 12 500 Kč + 200 FS", minDeposit: "250 Kč", wager: "35× (vklad + bonus)", highlight: "Vysoký bonus, transparentní podmínky" },
  { name: "Rabona",       bonus: "100% až do 12 500 Kč + 200 FS", minDeposit: "250 Kč", wager: "35× (vklad + bonus)", highlight: "Atraktivní, pravidelné promo akce a turnaje" },
  { name: "Legiano",      bonus: "Free spiny bez vkladu + bonus až 12 500 Kč", minDeposit: "0 Kč / vklad pro bonus", wager: "35× (výhry z free spinů)", highlight: "Bez počátečního vkladu, různé promo akce" },
  { name: "Casinia",      bonus: "100% až do 12 500 Kč + 200 FS", minDeposit: "250 Kč", wager: "35× (vklad + bonus)", highlight: "Vysoká celková hodnota, jasné podmínky" },
  { name: "Alf Casino",   bonus: "100% až do 20 000 Kč + 300 FS", minDeposit: "250 Kč", wager: "35× (vklad + bonus)", highlight: "Jednoduchý přístup a okamžitá odměna" },
];

const FAQ = [
  {
    q: "Co je to kasino bonus?",
    a: "Bonus v online kasinu je pobídka od platformy, která může zahrnovat peníze navíc, free spiny nebo cashback.",
  },
  {
    q: "Jsou bonusy v Česku legální?",
    a: "Ano, na licencovaných platformách jsou bonusy legální, pokud mají jasně definovaná pravidla pro jejich použití a protočení.",
  },
  {
    q: "Jak fungují požadavky na protočení?",
    a: "Vager (požadavek na protočení) je počet, kolikrát musíte vsadit celou částku bonusu, než si budete moci vybrat výhru. Například bonus 1 000 Kč s vagerem 30× vyžaduje sázky v celkové hodnotě 30 000 Kč.",
  },
  {
    q: "Jak si mohu vybrat výhru získanou z bonusu?",
    a: "Pro výběr musíte plně splnit požadavky na protočení v časovém limitu stanoveném pravidly. Poté budou prostředky dostupné k výběru běžnými metodami.",
  },
];

function BonusCard({ item }: { item: typeof TOP5[0] }) {
  const [open, setOpen] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(false);

  return (
    <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid={`bonus-card-${item.rank}`}>
      {/* Header bar */}
      <div className="flex items-center gap-3 px-4 sm:px-6 py-4 border-b border-[#eef1f7]" style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
        <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white/15 border border-white/30 flex items-center justify-center font-black text-white text-base sm:text-lg flex-shrink-0">
          {item.rank}
        </div>
        <div className="w-10 h-10 sm:w-[56px] sm:h-[56px] rounded-xl flex-shrink-0 overflow-hidden">
          <img src={item.logo} alt={item.name} className="w-full h-full object-cover" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-white/60 text-[10px] sm:text-xs font-semibold uppercase tracking-wider">{item.subline}</div>
          <div className="text-white font-black text-sm sm:text-lg leading-tight truncate">{item.headline}</div>
        </div>
        <div className="hidden sm:flex flex-col gap-2 flex-shrink-0">
          <a href={item.url} target="_blank" rel="sponsored noopener noreferrer">
            <Button size="sm" className="hraj-btn font-bold gap-1.5" style={{ background: "#ffffff", color: "#003da5" }} data-testid={`button-bonus-hraj-${item.rank}`}>
              Získat bonus <ArrowRight className="hraj-arrow w-3.5 h-3.5" />
            </Button>
          </a>
          <Link href={item.reviewUrl}>
            <button className="flex items-center justify-center gap-1 text-white/70 text-xs font-semibold hover:text-white transition-colors" data-testid={`button-bonus-review-${item.rank}`}>
              <BookOpen className="w-3 h-3" /> Přečíst recenzi
            </button>
          </Link>
        </div>
      </div>

      {/* Mobile collapsed: CTA + expand toggle */}
      <div className="sm:hidden p-4 space-y-3">
        <a href={item.url} target="_blank" rel="sponsored noopener noreferrer" className="block">
          <Button className="hraj-btn w-full font-bold gap-1.5" style={{ background: "#003da5", color: "#ffffff" }} data-testid={`button-bonus-hraj-mobile-${item.rank}`}>
            Získat bonus <ArrowRight className="hraj-arrow w-4 h-4" />
          </Button>
        </a>
        <Link href={item.reviewUrl}>
          <span className="flex items-center justify-center gap-1 py-1.5 text-[#003da5] text-xs font-semibold hover:text-[#002d7c] transition-colors cursor-pointer" data-testid={`button-bonus-review-mobile-${item.rank}`}>
            <BookOpen className="w-3 h-3 flex-shrink-0" />
            Přečíst recenzi
          </span>
        </Link>
        <button
          onClick={() => setMobileExpanded(!mobileExpanded)}
          className="w-full flex items-center justify-center gap-1.5 text-[#003da5] text-xs font-semibold hover:text-[#002d7c] transition-colors py-1"
          data-testid={`button-bonus-expand-mobile-${item.rank}`}
        >
          {mobileExpanded ? <><ChevronUp className="w-3.5 h-3.5" /> Skrýt podrobnosti</> : <><ChevronDown className="w-3.5 h-3.5" /> Zobrazit více</>}
        </button>
      </div>

      {/* Desktop: always show; Mobile: only when expanded */}
      <div className={`${mobileExpanded ? "block" : "hidden"} sm:block`}>
        {/* Casino screenshot */}
        {item.screenshot && (
          <div className="w-full overflow-hidden">
            <img src={item.screenshot} alt={`${item.name} – náhled kasina`} className="w-full h-auto block" />
          </div>
        )}

        <div className="p-6">
          {/* Pros / Cons */}
          <div className="grid sm:grid-cols-2 gap-4 mb-5">
            <div>
              <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                <CheckCircle className="w-3.5 h-3.5" /> Výhody
              </div>
              <ul className="space-y-1.5">
                {item.pros.map(p => (
                  <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                <XCircle className="w-3.5 h-3.5" /> Nevýhody
              </div>
              <ul className="space-y-1.5">
                {item.cons.map(c => (
                  <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                    <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <p className="text-gray-600 text-sm leading-relaxed mb-5">{item.desc}</p>

          {/* Key params */}
          <div className="bg-[#f3f6fb] rounded-xl p-4 mb-4">
            <div className="font-bold text-gray-900 text-sm mb-3">Klíčové parametry bonusu</div>
            <div className="grid sm:grid-cols-2 gap-2">
              {item.params.map(({ label, value }) => (
                <div key={label} className="flex flex-col">
                  <span className="text-gray-500 text-xs">{label}</span>
                  <span className="text-gray-900 font-semibold text-sm">{value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Expandable detail — on mobile when expanded via "Zobrazit více", show detail automatically */}
          <div className="hidden sm:block">
            <button
              onClick={() => setOpen(!open)}
              className="flex items-center gap-1.5 text-[#003da5] text-xs font-semibold hover:text-[#002d7c] transition-colors mb-3"
              data-testid={`button-bonus-detail-${item.rank}`}
            >
              {open ? <><ChevronUp className="w-3.5 h-3.5" /> Skrýt detail</> : <><ChevronDown className="w-3.5 h-3.5" /> Zobrazit detail</>}
            </button>
            {open && (
              <div className="space-y-3 mb-4">
                <p className="text-gray-600 text-sm leading-relaxed">{item.detail}</p>
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 flex items-start gap-2">
                  <AlertTriangle className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
                  <p className="text-amber-700 text-sm"><span className="font-bold">Tip pro hráče: </span>{item.tip}</p>
                </div>
              </div>
            )}
          </div>
          <div className="sm:hidden space-y-3 mb-4">
            <p className="text-gray-600 text-sm leading-relaxed">{item.detail}</p>
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 flex items-start gap-2">
              <AlertTriangle className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
              <p className="text-amber-700 text-sm"><span className="font-bold">Tip pro hráče: </span>{item.tip}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function FaqItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-[#eef1f7] last:border-0">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-4 text-left gap-4"
        data-testid={`faq-${q.slice(0, 20).replace(/\s/g, "-")}`}
      >
        <span className="font-semibold text-gray-900 text-sm">{q}</span>
        {open ? <ChevronUp className="w-4 h-4 text-[#003da5] flex-shrink-0" /> : <ChevronDown className="w-4 h-4 text-gray-400 flex-shrink-0" />}
      </button>
      {open && <p className="text-gray-600 text-sm leading-relaxed pb-4">{a}</p>}
    </div>
  );
}

export default function BonusyPage() {
  useSEO({ title: "Casino Bonusy 2026 – Uvítací bonus a free spiny | HrajBonus", description: "Srovnání nejlepších casino bonusů v ČR. Uvítací bonusy, free spiny bez vkladu, cashback a věrnostní programy. Aktualizováno denně. 18+",
  url: "https://hrajbonus.com/bonusy", });

  return (
    <div className="min-h-screen bg-[#f5f7fb]">
      <Header />

      {/* Hero */}
      <section className="relative pt-16 pb-0 overflow-hidden">
        <div className="absolute inset-0 z-0" style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }} />
        <div className="absolute inset-0 z-0 opacity-5" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize: "40px 40px" }} />
        <div className="relative z-10 max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-14 sm:py-16 text-center">
          <div className="flex flex-wrap items-center justify-center gap-3 mb-5">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 text-white/80 text-xs font-semibold uppercase tracking-widest">
              <Trophy className="w-3.5 h-3.5 text-[#f5c518]" /> Aktualizováno pro rok 2026
            </div>
            <div className="inline-flex items-center gap-1.5 bg-white/10 border border-white/20 rounded-full px-3 py-1.5 text-white/70 text-xs font-semibold" data-testid="badge-aktualizovano-bonusy">
              <Calendar className="w-3 h-3" /> Aktualizováno: 12. března 2026
            </div>
          </div>
          <h1 className="text-4xl sm:text-5xl font-black text-white leading-tight mb-4">
            Nejlepší casino bonusy v ČR
          </h1>
          <p className="text-white/75 text-lg leading-relaxed max-w-2xl mx-auto mb-8">
            Zde najdete nejkomplexnější průvodce s informacemi o hlavních bonusech online kasin v České republice pro hraní slotů, blackjacku, rulety a mnoha dalších her. Dozvíte se také, zda je možné získat bonusy bez vkladu pro hraní v live kasinu nebo jak získat přístup k nejlepším promocím českých online kasin a mnoho dalšího.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a href="#top5">
              <Button size="default" className="hraj-btn font-bold gap-2" style={{ background: "#ffffff", color: "#003da5" }}>
                Zobrazit TOP 5 bonusů <ArrowRight className="hraj-arrow w-4 h-4" />
              </Button>
            </a>
            <a href="#srovnani">
              <Button size="default" variant="outline" className="hraj-btn border-white/30 text-white font-semibold" style={{ background: "rgba(255,255,255,0.08)" }}>
                Srovnávací tabulka
              </Button>
            </a>
          </div>
        </div>
        <div className="relative z-10">
          <svg viewBox="0 0 1440 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full block" preserveAspectRatio="none" style={{ display: "block", verticalAlign: "bottom", height: "44px" }}>
            <rect x="0" y="40" width="1440" height="4" fill="#f5f7fb" />
            <path d="M0 44L1440 44L1440 0C1200 35 720 40 0 0L0 44Z" fill="#f5f7fb" />
          </svg>
        </div>
      </section>

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 space-y-10">

        {/* How to claim a bonus guide */}
        <section data-testid="section-how-to-claim">
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-2">Jak získat bonus ve 4 krocích</h2>
            <p className="text-gray-500 text-sm mb-6">Rychlý průvodce pro nové hráče — od registrace po první hru</p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {[
                { icon: UserPlus, step: "1", title: "Zaregistrujte se", desc: "Vytvořte si účet v kasinu a ověřte svou e-mailovou adresu." },
                { icon: CreditCard, step: "2", title: "Vložte vklad", desc: "Proveďte první vklad splňující minimální požadavky bonusu." },
                { icon: Sparkles, step: "3", title: "Aktivujte bonus", desc: "Bonus se přičte automaticky nebo zadejte promo kód." },
                { icon: Gamepad2, step: "4", title: "Hrajte a splňte podmínky", desc: "Sázejte na povolených hrách a splňte požadavky na protočení." },
              ].map(({ icon: Icon, step, title, desc }) => (
                <div key={step} className="relative bg-[#f0f5ff] border border-[#003da5]/10 rounded-xl p-5 text-center" data-testid={`how-to-step-${step}`}>
                  <div className="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style={{ background: "#003da5" }}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div className="text-[#003da5] text-xs font-bold uppercase tracking-wider mb-1">Krok {step}</div>
                  <div className="font-bold text-gray-900 text-sm mb-1">{title}</div>
                  <p className="text-gray-600 text-xs leading-relaxed">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* TOP 5 */}
        <section id="top5">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-black text-gray-900 mb-2">TOP 5 nejlepších kasino bonusů v Česku</h2>
            <p className="text-gray-500 text-base">Ověřené nabídky seřazené podle celkové hodnoty a férovosti podmínek</p>
          </div>
          <div className="space-y-6">
            {TOP5.map(item => <BonusCard key={item.rank} item={item} />)}
          </div>
        </section>

        {/* Comparison table */}
        <section id="srovnani">
          <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden">
            <div className="px-6 py-5 border-b border-[#eef1f7]">
              <h2 className="text-xl font-black text-gray-900">Srovnání nejlepších casino bonusů</h2>
            </div>
            <div className="overflow-x-auto max-h-[500px] overflow-y-auto">
              <table className="w-full text-sm">
                <thead className="sticky top-0 z-10">
                  <tr className="bg-[#f3f6fb]">
                    <th className="text-left px-5 py-3 font-bold text-gray-700 text-xs uppercase tracking-wide bg-[#f3f6fb]">Kasino</th>
                    <th className="text-left px-5 py-3 font-bold text-gray-700 text-xs uppercase tracking-wide bg-[#f3f6fb]">Uvítací bonus</th>
                    <th className="text-left px-5 py-3 font-bold text-gray-700 text-xs uppercase tracking-wide bg-[#f3f6fb]">Min. vklad</th>
                    <th className="text-left px-5 py-3 font-bold text-gray-700 text-xs uppercase tracking-wide bg-[#f3f6fb]">Wagering</th>
                    <th className="text-left px-5 py-3 font-bold text-gray-700 text-xs uppercase tracking-wide bg-[#f3f6fb]">Klíčové výhody</th>
                    <th className="px-5 py-3 bg-[#f3f6fb]" />
                  </tr>
                </thead>
                <tbody>
                  {COMPARISON.map((row, i) => (
                    <tr key={row.name} className={`border-t border-[#eef1f7] ${i % 2 === 1 ? "bg-[#fafbfe]" : ""}`}>
                      <td className="px-5 py-4 font-bold text-gray-900">{row.name}</td>
                      <td className="px-5 py-4 text-[#003da5] font-semibold">{row.bonus}</td>
                      <td className="px-5 py-4 text-gray-700">{row.minDeposit}</td>
                      <td className="px-5 py-4 text-gray-600">{row.wager}</td>
                      <td className="px-5 py-4 text-gray-600 text-xs max-w-[200px]">{row.highlight}</td>
                      <td className="px-5 py-4">
                        <a href={TOP5[i].url} target="_blank" rel="sponsored noopener noreferrer">
                          <Button size="sm" className="hraj-btn font-bold whitespace-nowrap" style={{ background: "#003da5", color: "#ffffff" }}>
                            Získat bonus
                          </Button>
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Key info before choosing */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-2">Klíčové informace před výběrem bonusu z našeho žebříčku</h2>
            <p className="text-gray-600 leading-relaxed mb-5">
              Před aktivací kasino bonusu je klíčové si pečlivě přečíst jeho podmínky. Hráči často dělají chybu, že přijmou promoakci, aniž by porozuměli omezením a požadavkům. Ve většině případů to vede k nemožnosti vybrat výhry nebo k úplné ztrátě bonusu. Abyste se vyhnuli zklamání, věnujte pozornost následujícím klíčovým bodům:
            </p>
            <div className="space-y-4">
              {[
                { title: "Podmínky a pravidla", desc: "Před aktivací jakéhokoli bonusu si přečtěte kompletní podmínky, nejen propagační upoutávky. To vám pomůže pochopit, kdo má na bonus nárok, jak ho přesně použít a za jakých okolností může být bonus zrušen." },
                { title: "Požadavek na protočení (Wager)", desc: "Jedná se o násobek, kolikrát musíte vsadit hodnotu bonusu (nebo bonusu a vkladu dohromady), než bude možné vybrat výhry. Čím nižší je wager, tím vyšší jsou vaše šance, že z bonusu budete skutečně profitovat." },
                { title: "Omezení her", desc: "Ne všechny hry se započítávají do plnění požadavků na protočení stejně. Hrací automaty se obvykle počítají ze 100 %. Stolní hry často přispívají jen 10–20 % nebo jsou zcela vyloučeny." },
                { title: "Minimální a maximální vklad", desc: "Výše vkladu ovlivňuje váš nárok na bonus. Minimální vklad pro promoakci může být vyšší než obecný minimální vklad kasina. Maximální částka zase udává, že ani vyšší vklad již hodnotu připsaného bonusu nezvýší." },
                { title: "Doba platnosti", desc: "Každý bonus má časové omezení pro jeho využití a splnění požadavků na protočení. Obvykle to bývá 3, 7, 14 nebo 30 dní." },
                { title: "Omezení platebních metod", desc: "Některá kasina vylučují určité platební systémy z účasti na bonusových programech." },
                { title: "Geografická omezení", desc: "Ne všechny bonusy jsou dostupné ve všech zemích. Kasina mohou omezit přístup na základě IP adresy nebo země pobytu." },
              ].map(({ title, desc }) => (
                <div key={title} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#003da5] mt-0.5 flex-shrink-0" />
                  <div>
                    <span className="font-bold text-gray-900 text-sm">{title}: </span>
                    <span className="text-gray-600 text-sm">{desc}</span>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mt-5 italic">
              Porozumění těmto nuancím vám pomůže chytře vybrat kasino s nejlepšími bonusy a využít tyto nabídky s maximálním přínosem.
            </p>
          </div>
        </section>

        {/* How to activate */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4">Jak aktivovat kasino bonus: Krok za krokem</h2>
            <p className="text-gray-600 leading-relaxed mb-5">
              Aktivace bonusu je rychlý a srozumitelný proces, pokud dodržíte správný postup. Zde je podrobný návod, který vám pomůže vše udělat správně a co nejrychleji:
            </p>
            <div className="space-y-4">
              {[
                ["Zaregistrujte se na webu kasina.", "Vyplňte registrační formulář a nezapomeňte zadat promo kód na bonus, pokud ho máte."],
                ["Proveďte první vklad.", "Zkontrolujte dostupné platební systémy a vložte částku, která spadá do povolených limitů."],
                ["Splňte požadavky na protočení.", "Sázejte na povolených hrách a sledujte pokrok ve svém osobním účtu."],
                ["Vyberte výhry.", "Po úplném splnění podmínek pro protočení se bonusové prostředky a výhry z nich stanou dostupnými k výběru."],
              ].map(([step, desc], i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center font-black text-white text-sm flex-shrink-0" style={{ background: "#003da5" }}>
                    {i + 1}
                  </div>
                  <div className="pt-1">
                    <span className="font-bold text-gray-900 text-sm">{step} </span>
                    <span className="text-gray-600 text-sm">{desc}</span>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-gray-500 text-sm mt-5 leading-relaxed">
              Dodržením těchto kroků můžete nejen aktivovat bonus, ale také dosáhnout reálného zisku. Tento průvodce vám pomůže vyhnout se běžným chybám.
            </p>
          </div>
        </section>

        {/* How to choose */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4">Jak vybrat bonus šitý na míru</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Neexistuje jeden univerzální 'nejlepší' bonus pro všechny. Pro nováčky může být ideální bonus bez vkladu nebo volná zatočení, která umožní prozkoumat kasino bez rizika. Naopak zkušení hráči, jako ti, kteří hledají odměny v kasinech jako Spinanga nebo Rabona, mohou preferovat vysoké vkladové bonusy s férovými podmínkami, které maximalizují jejich herní kapitál.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Vždy si položte otázku: Jaký typ hráče jsem? Hraji často a s vyššími sázkami, nebo jen příležitostně pro zábavu? Odpověď vám pomůže určit, zda je pro vás důležitější vysoká částka bonusu, nízké požadavky na protočení, nebo třeba dlouhá platnost nabídky. Pamatujte, že bonusy jsou marketingovým nástrojem kasin, jejichž cílem je zpříjemnit a prodloužit vaši hru, nikoliv garantovat zisk.
            </p>
          </div>
        </section>

        {/* Types of bonuses */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-5">Hlavní typy bonusů v online kasinech</h2>
            <p className="text-gray-600 leading-relaxed mb-5">
              Online kasina nabízejí množství bonusů, z nichž každý je navržen pro určitou fázi interakce s hráčem. Porozumění rozdílům mezi nimi vám pomůže vybrat si ty nejvýhodnější nabídky v závislosti na vašich preferencích a herním stylu.
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              {[
                { title: "Uvítací bonusy", desc: "Nejběžnější a nejštědřejší bonusy určené pro nové hráče. Obvykle zahrnují 100–200% navýšení k prvnímu vkladu (nebo několika vkladům) a zatočení zdarma (free spiny) na populárních automatech." },
                { title: "Bonusy bez vkladu", desc: "Vzácné, ale velmi lákavé nabídky. Kasino připíše malou finanční částku nebo balíček free spinů ihned po registraci nebo za splnění úkolů. Tyto bonusy mívají vysoké požadavky na protočení a limity pro výběr, ale umožňují vám otestovat kasino bez rizika." },
                { title: "Zatočení zdarma (Free Spiny)", desc: "Free spiny jsou bezplatná zatočení na určených hracích automatech. Mohou být poskytnuty jako součást uvítacího balíčku, v rámci různých promoakcí nebo za splnění úkolů na webu. Někdy jsou bez požadavku na protočení, což umožňuje okamžitý výběr výher." },
                { title: "Cashback", desc: "Jedná se o vrácení části prohraných prostředků za určité období (obvykle za týden). Méně často se cashback počítá z celkové částky vkladů. Tyto bonusy zřídka vyžadují protočení, a pokud ano, požadavek je minimální." },
                { title: "Reload bonusy", desc: "Tato pobídka je určena pro stálé hráče získávající bonusy při opakovaných vkladech. Částečně jsou podobné uvítacím balíčkům, ale s méně výhodnými podmínkami. Reload bonusy obvykle nabízejí 50–100 % k částce opakovaného vkladu." },
                { title: "Věrnostní programy a VIP kluby", desc: "Pravidelní hráči se automaticky účastní systémů sbírání bodů za sázky. Tyto body lze směnit za peníze, free spiny nebo jiné bonusy. VIP programy nabízejí osobní nabídky, rychlejší výplaty a větší bonusy se sníženými požadavky na protočení." },
              ].map(({ title, desc }) => (
                <div key={title} className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-2">{title}</div>
                  <p className="text-gray-600 text-sm leading-relaxed">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pros and cons of bonuses */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4">Výhody a nevýhody kasino bonusů</h2>
            <p className="text-gray-600 leading-relaxed mb-5">
              Bonusy jsou skvělým nástrojem pro přilákání hráčů a udržení jejich herní aktivity. Mají ale své klady a zápory. Před souhlasem s účastí v promoakci stojí za to zvážit všechna pro a proti, abyste se vyhnuli nepříjemným překvapením.
            </p>
            <div className="grid sm:grid-cols-2 gap-6">
              <div>
                <div className="flex items-center gap-1.5 font-bold text-green-700 text-sm uppercase tracking-wide mb-3">
                  <CheckCircle className="w-4 h-4" /> Výhody bonusů
                </div>
                <ul className="space-y-2">
                  {["Více času na hraní", "Možnost hrát zdarma", "Kompenzace ztrát", "Další příležitosti a exkluzivní nabídky"].map(item => (
                    <li key={item} className="flex items-start gap-2 text-gray-700 text-sm">
                      <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <div className="flex items-center gap-1.5 font-bold text-red-600 text-sm uppercase tracking-wide mb-3">
                  <XCircle className="w-4 h-4" /> Nevýhody bonusů
                </div>
                <ul className="space-y-2">
                  {["Vysoké požadavky na protočení", "Omezená doba platnosti", "Omezení na hry", "Vyloučení platebních systémů a zemí"].map(item => (
                    <li key={item} className="flex items-start gap-2 text-gray-700 text-sm">
                      <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mt-5">
              Pokud jsou bonusy využívány vědomě, mohou se stát skvělým nástrojem pro úspěšnou hru. Je důležité, aby si uživatel kasina předem pečlivě přečetl podmínky a vybíral si jen ty nabídky, které skutečně odpovídají jeho hernímu stylu a rozpočtu.
            </p>
          </div>
        </section>

        {/* Where bonuses can be used */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4">Kde můžete využít bonusy online kasin</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Kasino bonusy lze uplatnit v různých herních formátech. Nejoblíbenější kategorií jsou online hrací automaty. Většina dárků, zejména uvítací balíčky a free spiny, je určena právě pro virtuální herní automaty — důkazem jsou podmínky promoakcí, kde se 100 % započítává do plnění požadavků na protočení.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              Kromě automatů lze bonusy někdy využít i ve stolních hrách, jako je blackjack, ruleta nebo video poker. Zde je však třeba pamatovat na to, že mnoho z těchto her se do plnění požadavků na protočení započítává jen částečně nebo vůbec.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              Některé bonusy mohou být dostupné pro live hry s reálnými dealery. To je obzvláště atraktivní pro hráče, kteří preferují atmosféru skutečného kasina. Live hry jsou však často z bonusových aktivit vyloučeny nebo mají minimální příspěvek k protočení.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Různé dárky jsou pro hráče užitečné k seznámení se s novou platformou a k obnovení zůstatku po velké prohře. Poskytují jednu nebo více herních seancí bez rizika, ale s reálnou šancí získat peníze na svůj účet.
            </p>
          </div>
        </section>

        {/* Tips */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4">Tipy pro maximalizaci kasino bonusů</h2>
            <p className="text-gray-600 leading-relaxed mb-5">
              Ani ty nejštědřejší bonusy nepřinesou užitek, pokud je používáte bez strategie a porozumění jejich mechanice. Abyste z nabídek kasina vytěžili maximum, je důležité nejen promoakci aktivovat, ale také obratně spravovat získané prostředky ve všech fázích jejich použití.
            </p>
            <div className="space-y-3">
              {[
                "Dávejte přednost uvítacím bonusům, ale pečlivě čtěte podmínky akcí. To vám pomůže pochopit, jak moc je nabídka skutečně vhodná pro úspěšnou hru.",
                "Využívejte free spiny na automatech. Tento typ her nabízí nejvíce příležitostí k výběru výher po splnění požadavků na protočení bonusu.",
                "Vyhýbejte se nelicencovaným a pochybným kasinům. Nabízejí ty nejlákavější uvítací balíčky, ale dělají vše pro to, aby hráči své výplaty nikdy neobdrželi.",
              ].map((tip, i) => (
                <div key={i} className="flex items-start gap-3 bg-[#f0f5ff] border border-[#003da5]/10 rounded-xl p-4">
                  <Star className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                  <p className="text-gray-700 text-sm leading-relaxed">{tip}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Common problems */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4">Běžné problémy s bonusy a jejich řešení</h2>
            <p className="text-gray-600 leading-relaxed mb-5">
              Někdy, i při dodržení všech pravidel, se bonus nemusí aktivovat nebo může zmizet. To může hráče, zejména nováčky, zmást. Zde jsou nejčastější problémy a doporučení k jejich řešení:
            </p>
            <div className="space-y-3">
              {[
                { prob: "Bonus se nezobrazuje na účtu.", sol: "Zkontrolujte, zda jste splnili všechny podmínky: minimální vklad, správná platební metoda, použití promo kódu atd." },
                { prob: "Bonus se po vkladu neaktivoval.", sol: "Obraťte se na zákaznickou podporu. Často mohou bonus připsat ručně, pokud došlo k technické chybě a všechny podmínky byly splněny." },
                { prob: "Nejsou uvedeny podmínky protočení nebo jiná omezení.", sol: "Kontaktujte zákaznickou podporu a vyžádejte si dokument s kompletními podmínkami a pravidly promoakce." },
                { prob: "Potřebujete zrušit aktivní bonus.", sol: "Pokud z nějakého důvodu chcete účast v akci předčasně ukončit, kontaktujte podporu a požádejte o ruční odstranění bonusu z účtu." },
              ].map(({ prob, sol }) => (
                <div key={prob} className="flex items-start gap-3">
                  <AlertTriangle className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" />
                  <div>
                    <span className="font-semibold text-gray-900 text-sm">{prob} </span>
                    <span className="text-gray-600 text-sm">{sol}</span>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-gray-500 text-sm mt-5 leading-relaxed">
              Včasným kontaktováním podpory a kontrolou podmínek lze většinu problémů s bonusy vyřešit rychle a bez následků. Hlavní je neignorovat drobný tisk a nebát se klást otázky.
            </p>
          </div>
        </section>

        {/* Licensed casinos */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4">Proč je důležité vybírat si licencovaná online kasina?</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Výběr kasina s platnou licencí je základem bezpečnosti hráče. Tento dokument potvrzuje, že provozovatel prošel kontrolou regulačních orgánů. To znamená, že dodržuje zákony a standardy poskytování služeb, zajišťuje férové podmínky a ochranu údajů uživatelů.
            </p>
            <p className="text-gray-600 leading-relaxed mb-5">
              Licencovaná kasina jsou povinna používat certifikované RNG (generátory náhodných čísel), zveřejňovat férové bonusové podmínky a umožňovat uživatelům podávat stížnosti k arbitráži ve sporných situacích. To je zvláště důležité v kontextu bonusových nabídek — nečestná kasina mohou měnit pravidla 'za pochodu', rušit výhry bez vysvětlení nebo dokonce blokovat účty. Licence je zárukou, že práva hráčů jsou chráněna a že bonusy odpovídají uvedeným podmínkám.
            </p>
            <div className="flex items-start gap-3 bg-green-50 border border-green-200 rounded-xl p-4">
              <Shield className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
              <p className="text-green-800 text-sm leading-relaxed">
                <span className="font-bold">Všechna kasina v naší TOP 5 mají platnou licenci</span> a jsou prověřena naším redakčním týmem. Hrajte zodpovědně — pouze na licencovaných platformách.
              </p>
            </div>
          </div>
        </section>

        {/* Is it worth it */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4">Vyplatí se hrát v kasinu s využitím bonusů?</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Kasino bonusy mohou pomoci zvýšit vaše šance na výhru, otestovat různé hry bez zbytečného rizika a prodloužit herní seanci. Je však nutné je používat s rozumem.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              Před aktivací jakéhokoli bonusu je nezbytné pečlivě prostudovat jeho podmínky: požadavky na protočení, povolené hry, dobu platnosti a omezení platebních metod. Zodpovědný přístup k promoakcím pomáhá předcházet zklamání a mění hru v pohodlnou a výhodnou zábavu.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Při správném výběru platformy a bonusu získáte nejen šanci na výhru, ale také pozitivní herní zážitek. Ten vám v budoucnu pomůže uskutečnit ještě více úspěšných sázek na nejlepších hracích automatech.
            </p>
          </div>
        </section>

        {/* Internal links */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-5 shadow-sm">
            <p className="text-sm text-gray-600 leading-relaxed">
              <span className="font-bold text-gray-900">Kasina s nejlepšími bonusy: </span>
              <a href="/kasina/fastslots" className="text-[#003da5] hover:underline" data-testid="bonusy-link-fastslots">Fast Slots</a>
              {" · "}
              <a href="/kasina/instant-casino" className="text-[#003da5] hover:underline" data-testid="bonusy-link-instant">Instant Casino</a>
              {" · "}
              <a href="/kasina/golden-panda" className="text-[#003da5] hover:underline" data-testid="bonusy-link-golden">Golden Panda</a>
              {" · "}
              <a href="/kasina/onlyspins" className="text-[#003da5] hover:underline" data-testid="bonusy-link-onlyspins">OnlySpins</a>
              {" · "}
              <a href="/kasina/wazamba" className="text-[#003da5] hover:underline" data-testid="bonusy-link-wazamba">Wazamba</a>
              {" · "}
              <a href="/kasina/alf-casino" className="text-[#003da5] hover:underline" data-testid="bonusy-link-alf">Alf Casino</a>
              {" · "}
              <a href="/porovnat" className="text-[#003da5] hover:underline font-semibold" data-testid="bonusy-link-porovnat">Porovnat kasina</a>
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <div className="flex items-center gap-2 mb-5">
              <HelpCircle className="w-5 h-5 text-[#003da5]" />
              <h2 className="text-2xl font-black text-gray-900">FAQ</h2>
            </div>
            <div>
              {FAQ.map(item => <FaqItem key={item.q} q={item.q} a={item.a} />)}
            </div>
          </div>
        </section>

        {/* Bottom disclaimer */}
        <div className="flex items-center justify-center gap-2 text-xs text-gray-400 font-medium pb-4">
          <Shield className="w-3.5 h-3.5" />
          <span>Pouze kasina s platnou licencí. 18+ | Hrajte zodpovědně | Podmínky se vztahují |{" "}
            <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer" className="hover:underline" data-testid="link-gamcare-bonusy">GamCare</a>{" "}|{" "}
            <a href="https://www.mfcr.cz/" target="_blank" rel="noopener noreferrer" className="hover:underline" data-testid="link-mfcr-bonusy">MF ČR</a>
          </span>
        </div>

      </div>
      <Footer />
    </div>
  );
}
